import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import $ from 'jquery';

let idIssuePlace = {
  5001: 'Ilam',
  5002: 'Jhapa',
  5003: 'Panchthar',
  5004: 'Taplejung',
  5005: 'Bhojpur',
  5006: 'Dhankuta',
  5007: 'Morang',
  5008: 'Sankhuwasabha',
  5009: 'Sunsari',
  5010: 'Terhathum',
  5011: 'Khotang',
  5012: 'Okhaldhunga',
  5013: 'Saptari',
  5014: 'Siraha',
  5015: 'Solukhumbu',
  5016: 'Udayapur',
  5017: 'Dhanusa',
  5018: 'Dolakha',
  5019: 'Mahottari',
  5020: 'Ramechhap',
  5021: 'Sarlahi',
  5022: 'Sindhuli',
  5023: 'Bhaktapur',
  5024: 'Dhading',
  5025: 'Kathmandu',
  5026: 'Kavrepalanchok',
  5027: 'Lalitpur',
  5028: 'Nuwakot',
  5029: 'Rasuwa',
  5030: 'Sindhupalchok',
  5031: 'Gorkha',
  5032: 'Kaski',
  5033: 'Lamjung',
  5034: 'Manang',
  5035: 'Syangja',
  5036: 'Tanahu',
  5037: 'Bara',
  5038: 'Chitawan',
  5039: 'Makwanpur',
  5040: 'Parsa',
  5041: 'Rautahat',
  5042: 'Dolpa',
  5043: 'Humla',
  5044: 'Jumla',
  5045: 'Kalikot',
  5046: 'Mugu',
  5047: 'Dang',
  5048: 'Pyuthan',
  5049: 'Rolpa',
  5050: 'Rukum',
  5051: 'Salyan',
  5052: 'Banke',
  5053: 'Bardiya',
  5054: 'Dailekh',
  5055: 'Jajarkot',
  5056: 'Surkhet',
  5057: 'Achham',
  5058: 'Bajhang',
  5059: 'Bajura',
  5060: 'Doti',
  5061: 'Kailali',
  5062: 'Baglung',
  5063: 'Mustang',
  5064: 'Myagdi',
  5065: 'Parbat',
  5066: 'Arghakhanchi',
  5067: 'Gulmi',
  5068: 'Kapilvastu',
  5069: 'Nawalparasi',
  5070: 'Palpa',
  5071: 'Rupandehi',
  5072: 'Baitadi',
  5073: 'Dadeldhura',
  5074: 'Darchula',
  5075: 'Kanchanpur',
  5076: 'Rukum West',
  5077: 'Nawalparasi West',
};

let idType = {
  1301: 'Citizenship',
  1302: 'Passport',
  10984: 'Aadhaar card',
  10988: 'Driving License',
  10989: 'PAN Card',
};

let occupation = {
  8080: 'Businessman',
  8081: 'Salaried',
  8082: 'Self employed',
  8083: 'Retiree',
  8084: 'Student',
  8085: 'Housewife',
  8086: 'Armed police personnel (Police, Army etc.)',
  8087: 'Government employee',
  8088: 'Professional worker (farmer, teacher, engineer, doctor, lawyer etc.)',
  8089: 'Unemployed',
};

let sourceOfFund = {
  8051: 'Salary',
  8052: 'Business',
  8070: 'Salary / Wages',
  8071: 'Bonus / Commission',
  8073: 'Savings or accumulated',
  8074: 'Part time job',
  8075: 'Own business',
  8076: 'Investment',
  8077: 'Lottery',
  8078: 'Gifts and donation',
  8079: 'Loan from bank',
};

let relationship = {
  8011: 'Spouse',
  2101: 'Father',
  2102: 'Mother',
  2103: 'Grand Father',
  2104: 'Grand Mother',
  2105: 'Husband',
  2106: 'Wife',
  2107: 'Father in Law',
  2108: 'Mother in Law',
  2109: 'Brother',
  2110: 'Brother in Law',
  2111: 'Sister',
  2112: 'Sister in Law',
  2113: 'Son',
  2114: 'Daughter',
  2115: 'Uncle',
  2116: 'Aunty',
  2117: 'Cousin',
  2118: 'Nephew',
  2119: 'Niece',
  2120: 'Friend',
  2121: 'Self',
};

function ImeMoneyTransfer() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [data, setData] = useState(false);
  const [commissionData, setCommissionData] = useState(false);
  const [base64, setBase64] = useState(false);
  const [idProof, setIdProof] = useState(false);
  const [processId, setProcessId] = useState('');
  const [searchBy, setSearchBy] = useState("mobile");
  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [addReceiverModal, setAddReceiverModal] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [paymentData, setPaymentData] = useState(false);
  const [bankName, setBankName] = useState(false);
  const [bankBranchName, setBankBranchName] = useState(false);
  const [states1, setStates1] = useState(false);
  const [states2, setStates2] = useState(false);
  const [districts1, setDistricts1] = useState(false);
  const [districts2, setDistricts2] = useState(false);
  const [municiple, setMuniciple] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setViewData(false);
    setAddReceiverModal(false);
    setErrors(false);
    setProcessId("");
  }
  const handleShow = () => setShowModal(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (processId) {
      const { otp } = e.target;
      let reqData = {
        new_sender_otp: otp.value,
        customer_token: processId.customer_token,
        otp_token: processId.otp_token
      };
      try {
        const response = await axios.post('/v2/imeremittance/confirm/customer', reqData);
        const { status, message } = response.data;
        if (status) {
          setShowModal(false);
        }
        toast(message);
      }
      catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
    else {
      const form = e.target;
      let jsonData = {};
      let errorData = {};
      Array.from(form.elements).forEach((item) => {
        if (item.name) {
          if (item.value == "" && item.getAttribute("requiredField")) {
            errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
          }
          jsonData[item.name] = item.value;
        }
      });
      jsonData['dob'] = jsonData['dob'].replace(/-/g, "/");
      jsonData['nationality	'] = jsonData['country'];
      jsonData['photo'] = base64 && base64.photo && base64['photo'];
      jsonData['id_proof'] = base64 && base64.id_proof && base64['id_proof'];
      if (Object.entries(errorData).length > 0) {
        setErrors(errorData);
      }
      else {
        try {
          let data = { ...jsonData };
          const response = await axios.post('/v2/imeremittance/create/customer', data);
          const { status, message } = response.data;
          if (status) {
            if (response.data.data.otp_token) {
              setProcessId(response.data.data);
            }
            else {
              setShowModal(false);
            }
          }
          toast(message);
        } catch (error) {
          if (error?.response?.data?.message) {
            toast(error.response.data.message);
          }
        }
      }
    }
  };

  const addReceiverSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    jsonData['receiver_nationality'] = "NPL";
    jsonData['forex_session_id'] = commissionData && commissionData.forex_session_id;
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        if (!jsonData?.otp) {
          let url = (data && data.sender.registered_by != "kyc") ? "/v2/imeremittance/send/transaction" : "/v2/imeremittance/send/transactionV2";
          const response = await axios.post(url, jsonData);
          //const response = await axios.post('/v2/imeremittance/send/transactionV2', jsonData);
          const { status, message } = response.data;
          if (status) {
            setProcessId(response.data);
          }
          toast(message);
        }
        else {
          let getData = {
            referance_number: processId.referance_number,
            otp_token: processId.otptoken,
            otp: jsonData?.otp,
          };
          let url = (data && data.sender.registered_by != "kyc") ? "/v2/imeremittance/confirm/transaction" : "/v2/imeremittance/confirm/transactionV2";
          const response = await axios.post(url, getData);
          //const response = await axios.post('/v2/imeremittance/confirm/transactionV2', getData);
          const { status, message } = response.data;
          if (status) {
            toast(message);
            //setAddReceiverModal(false);
          }
          else {
            toast(message);
            //setAddReceiverModal(false);
          }
          handleClose();
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const handleViewData = (index) => {
    setViewIndex(index);
    setViewData(true);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { search_by, id_number, mobile } = e.target;
    const isValid = /^\d{10}$/.test(mobile.value);
    if (!isValid) {
      setErrors({ mobile: "Mobile should be 10 number" });
    }
    else {
      setErrors(false);
      let data = {};
      let url = "";
      if (search_by.value == "id") {
        data = {
          type: "id_number",
          mobile_number: id_number.value
        };
        url = '/v2/imeremittance/check/customer';
      }
      else {
        data = {
          type: "mobile",
          mobile_number: mobile.value
        };
        url = '/v2/imeremittance/check/customer';
      }
      try {
        const response = await axios.post(url, data);
        const { status, message } = response.data;
        if (status) {
          setData(response.data);
        }
        else {
          toast(response.data.data || message);
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const getStateData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/imeremittance/get/state', { country_id: e.target.value });
      const { status } = response.data;
      if (status) {
        if (e.target.name == "country") {
          setIdProof(e.target.value);
          setStates1(response.data.data);
        }
        else {
          setStates2(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getDistrictData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/imeremittance/get/district', { state_id: e.target.value });
      const { status } = response.data;
      if (status) {
        if (e.target.name == "state" || e.target.name == "receiver_state") {
          setDistricts1(response.data.data);
        }
        else {
          setDistricts2(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getMunicipleData = async (e, idProof) => {
    deleteError(e);
    setMuniciple(false);
    if (idProof == "NPL") {
      try {
        const response = await axios.post('/v2/imeremittance/get/municiple', { district_id: e.target.value });
        const { status } = response.data;
        if (status) {
          setMuniciple(response.data.data);
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const getBankBranch = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/imeremittance/get/bank/branch', { bank_id: e.target.value });
      const { status } = response.data;
      if (status) {
        setBankBranchName(response.data.data);
        getPaymentMode(e);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData = async () => {
    try {
      const response = await axios.post('/v2/imeremittance/get/banks', { country_id: "NPL" });
      const { status } = response.data;
      if (status) {
        setBankName(response.data.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (currentUser && currentUser.imeMoneyTransfer == false) {
      navigate('/admin/dashboard');
    }
  }, [currentUser]);

  const getPaymentMode = (e) => {
    deleteError(e);
    setPaymentData({ ...paymentData, [e.target.name]: e.target.value });
  };

  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
    }
  };

  const handleFileChange = (e) => {
    deleteError(e);
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setBase64({ ...base64, [e.target.name]: base64String });
      };
      reader.readAsDataURL(file);
    }
  };

  const getServiceCharge = async (e, serviceData) => {
    deleteError(e);
    let price = e.target.value;
    if (price >= 700 && price <= 50000) {
      let requestData = {
        payment_type: serviceData.payment_type,
        remit_amount: price,
        bank_id: serviceData.bank_id,
        mobile_number: data && data.sender.MobileNo,
        registered_by: data && data.sender.registered_by,
      };
      try {
        let url = (requestData.registered_by != "kyc") ? "/v2/imeremittance/get/calculation" : "/v2/imeremittance/get/calculationV2";
        let response = await axios.post(url, requestData);
        //let response = await axios.post('/v2/imeremittance/get/calculationV2', requestData);
        const { status, message, data } = response.data;
        if (status) {
          setCommissionData(data);
        }
        else {
          toast(message);
        }
      }
      catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
    else {
      setCommissionData(false);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                Search Sender (IME Money Transfer)
                <Button className="float-right" variant="primary" onClick={handleShow}>
                  Add
                </Button>
              </h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Search By</label>
                    <select className="form-control" name="search_by" onChange={(e) => setSearchBy(e.target.value)}>
                      <option value="mobile">Mobile Number</option>
                      <option value="id">ID Number</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    {
                      searchBy == "id" ? (
                        <>
                          <label>ID Number</label>
                          <input className="form-control" type="number" name="id_number" required />
                        </>
                      ) : (
                        <>
                          <label>Mobile</label>
                          <input className="form-control" type="number" name="mobile" />
                          <span className="error">{errors && errors?.mobile}</span>
                        </>
                      )
                    }
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {
                data && (
                  <>
                    <h4 className="card-title">
                      Sender/Receiver Data
                      <Button className="float-right" variant="primary" onClick={(e) => setAddReceiverModal(true)}>
                        Add Receiver
                      </Button>
                    </h4>
                    <div className="col-lg-12 transactionDetail">
                      <div>Total Transactions: {data.transactions_done_all}/{data.transactions_allowed}</div>
                      <div>Available Transactions: {data.transactions_allowed - data.transactions_done_all}</div>
                    </div>
                    <hr />
                    <ul className="showData">
                      {Object.entries(data.sender).map(([key, value]) => (
                        (!['_id', 'created_at', 'updated_at', '__v'].includes(key) && typeof value != 'object' && value != "" && value != null) && (
                          <li key={key}>
                            <strong>{addSpaceBetweenCases(key)}:</strong>
                            {
                              key == "IdPlaceOfIssue" ? (
                                <div>{idIssuePlace[value]}</div>
                              ) : key == "IdType" ? (
                                <div>{idType[value]}</div>
                              ) : (
                                <div>{value}</div>
                              )
                            }
                          </li>
                        )
                      ))}
                    </ul>
                    <DataTable
                      value={data.receiver}
                      size="small"
                      className="custom-table"
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="receiver_name"
                        header="Name"
                        sortable
                        body={(rowData) => <span data-label="Name">{rowData?.receiver_name}</span>}
                      />
                      <Column
                        field="receiver_mobile_number"
                        header="Mobile"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData.receiver_mobile_number}</span>}
                      />
                      <Column
                        field="payment_type"
                        header="Payment Type"
                        sortable
                        body={(rowData) => <span data-label="PaymentType">{rowData?.payment_type}</span>}
                      />
                      <Column
                        field="receiver_gender"
                        header="Gender"
                        sortable
                        body={(rowData) => <span data-label="Gender">{rowData.receiver_gender}</span>}
                      />
                      <Column
                        field="relationship"
                        header="Relationship"
                        sortable
                        body={(rowData) => <span data-label="Relationship">{rowData.relationship}</span>}
                      />
                      <Column
                        field="bank_id"
                        header="Bank Name"
                        sortable
                        body={(rowData) => <span data-label="BankName">{rowData.bank_id}</span>}
                      />
                      <Column
                        field="bank_account_number"
                        header="Account Number"
                        sortable
                        body={(rowData) => <span data-label="AccountNumber">{rowData.bank_account_number}</span>}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <button className="btn btn-primary" onClick={() => handleViewData(rowIndex)}>Send</button>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose} centered size={processId == "" ? 'xl' : 'sm'} backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Create New Sender</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              processId == "" ? (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <label>Mobile Number</label>
                        <input className="form-control" type="number" name="mobile_number" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.mobile_number}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Full Name</label>
                        <input className="form-control" type="text" name="fullName" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.fullName}</span>
                      </div>
                      {/* <div className="col-lg-4 col-md-4">
                        <label>First Name</label>
                        <input className="form-control" type="text" name="first_name" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.first_name}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Middle Name</label>
                        <input className="form-control" type="text" name="middle_name" onChange={deleteError} />
                        <span className="error">{errors && errors?.middle_name}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Last Name</label>
                        <input className="form-control" type="text" name="last_name" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.last_name}</span>
                      </div> */}
                      <div className="col-lg-4 col-md-4">
                        <label>Martial Status</label>
                        <select className="form-control" name="marital_status" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="1901">Married</option>
                          <option value="1902">Un Married</option>
                        </select>
                        <span className="error">{errors && errors?.marital_status}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Gender</label>
                        <select className="form-control" name="gender" onChange={deleteError} requiredField="true">
                          <option value="">Select Gender</option>
                          <option value="1801">Male</option>
                          <option value="1802">Female</option>
                          <option value="1803">Other</option>
                        </select>
                        <span className="error">{errors && errors?.gender}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Date of birth</label>
                        <input className="form-control" type="date" name="dob" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.dob}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Father or Mother Name</label>
                        <input className="form-control" type="text" name="father_or_mother_name" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.father_or_mother_name}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <p>Permanent Address</p>
                      <div className="col-lg-4 col-md-4">
                        <label>Country</label>
                        <select className="form-control" name="country" onChange={getStateData} requiredField="true">
                          <option value="">--Select--</option>
                          {/* <option value="IND">India</option> */}
                          <option value="NPL">Nepal</option>
                        </select>
                        <span className="error">{errors && errors?.country}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>State</label>
                        <select className="form-control" name="state" onChange={getDistrictData} requiredField="true">
                          <option value="">--Select--</option>
                          {states1 && states1.map((state, index) => (
                            <option value={state.state_id}>
                              {state.State}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.state}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>District</label>
                        <select className="form-control" name="district" onChange={(e) => getMunicipleData(e, idProof)} requiredField="true">
                          <option value="">--Select--</option>
                          {districts1 && districts1.map((district, index) => (
                            <option value={district.district_id}>
                              {district.district}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.district}</span>
                      </div>
                      {
                        municiple && (
                          <div className="col-lg-4 col-md-4">
                            <label>Municipality</label>
                            <select className="form-control" name="municipality" onChange={deleteError} requiredField="true">
                              <option value="">--Select--</option>
                              {municiple && municiple.map((mc, index) => (
                                <option value={mc.municipality_id}>
                                  {mc.municipality}
                                </option>
                              ))}
                            </select>
                            <span className="error">{errors && errors?.municipality}</span>
                          </div>
                        )
                      }
                      <div className="col-lg-4 col-md-4">
                        <label>Address</label>
                        <input className="form-control" type="text" name="address" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.address}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <p>Temporary Address</p>
                      <div className="col-lg-4 col-md-4">
                        <label>Country</label>
                        <select className="form-control" name="temp_country" onChange={getStateData} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="IND">India</option>
                          {/* <option value="NPL">Nepal</option> */}
                        </select>
                        <span className="error">{errors && errors?.temp_country}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>State</label>
                        <select className="form-control" name="temp_state" onChange={getDistrictData} requiredField="true">
                          <option value="">--Select--</option>
                          {states2 && states2.map((state, index) => (
                            <option value={state.state_id}>
                              {state.State}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.temp_state}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>District</label>
                        <select className="form-control" name="temp_district" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {districts2 && districts2.map((district, index) => (
                            <option value={district.district_id}>
                              {district.district}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.temp_district}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Address</label>
                        <input className="form-control" type="text" name="temp_address" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.temp_address}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <p>Identity Proof</p>
                      {
                        (idProof && idProof == "NPL") ? (
                          <>
                            <div className="col-lg-4 col-md-4">
                              <label>ID Issue Place</label>
                              <select className="form-control" name="id_place_of_issue" onChange={deleteError} requiredField="true">
                                <option value="">--Select--</option>
                                {
                                  Object.entries(idIssuePlace).map(([index, issue]) => (
                                    <option value={index}>{issue}</option>
                                  ))
                                }
                              </select>
                              <span className="error">{errors && errors?.id_place_of_issue}</span>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <label>ID Type</label>
                              <select className="form-control" name="id_type" onChange={deleteError} requiredField="true">
                                <option value="">--Select--</option>
                                <option value="1301">Citizenship</option>
                                <option value="1302">Passport</option>
                              </select>
                              <span className="error">{errors && errors?.id_type}</span>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-lg-4 col-md-4">
                              <label>ID Type</label>
                              <select className="form-control" name="id_type" onChange={deleteError} requiredField="true">
                                <option value="">--Select--</option>
                                <option value="10984">Aadhaar card</option>
                                <option value="10988">Driving License</option>
                                <option value="10989">PAN Card</option>
                              </select>
                              <span className="error">{errors && errors?.id_type}</span>
                            </div>
                          </>
                        )
                      }
                      <div className="col-lg-4 col-md-4">
                        <label>ID Number</label>
                        <input className="form-control" type="text" name="id_number" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.id_number}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Photo</label>
                        <input className="form-control" type="file" name="photo" onChange={handleFileChange} requiredField="true" />
                        <span className="error">{errors && errors?.photo}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>ID Proof</label>
                        <input className="form-control" type="file" name="id_proof" onChange={handleFileChange} requiredField="true" />
                        <span className="error">{errors && errors?.id_proof}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <label>OTP</label>
                        <input className="form-control" type="number" name="otp" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.otp}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Create Customer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={viewData} onHide={handleClose} centered size='xl' backdrop="static">
        <Form onSubmit={addReceiverSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Receiver Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              (data && data.receiver && (data.receiver).length > 0) && (
                <>
                  <ul className="showData">
                    <input type="hidden" name="sender_mobile_number" value={data && data.sender.MobileNo} />
                    <input type="hidden" name="sender_name" value={data && [data.sender.FirstName, data.sender.MiddleName, data.sender.LastName].filter(Boolean).join(" ")} />
                    <input type="hidden" name="sender_occupation" value={data && data.sender.Occupation} />
                    {Object.entries(data.receiver[viewIndex]).map(([key, value]) => (
                      (!['_id', 'sender_id', 'user_id', 'created_at', 'updated_at', '__v'].includes(key) && typeof value != 'object' && value != "" && value != null) && (
                        <>
                          <input type="hidden" name={key} value={value} />
                          <li key={key}>
                            <strong>{addSpaceBetweenCases(key)}:</strong>
                            {
                              key == "id_place_of_issue" ? (
                                <div>{value}</div>
                              ) : (
                                <div>{value}</div>
                              )
                            }
                          </li>
                        </>
                      )
                    ))}
                    {/* <li>
                      <strong>Transfer Amount (₹):</strong>
                      <div><input className="form-control" type="number" name="transferAmount" required /></div>
                    </li> */}
                    <li>
                      <strong>Remittance Reason:</strong>
                      <div>
                        <select className="form-control" name="remittanceReason" required>
                          <option value="">--Select--</option>
                          <option value="Family Maintenance">Family Maintenance</option>
                          <option value="Medical Expenses">Medical Expenses</option>
                        </select>
                      </div>
                    </li>
                    <li>
                      <label>Transfer Amount(in ₹)</label>
                      <input className="form-control" type="number" name="collect_amount" onChange={(e) => getServiceCharge(e, data.receiver[viewIndex])} min="700" max="50000" requiredField="true" />
                      <span className="error">{errors && errors?.collect_amount}</span>
                    </li>
                    <li>
                      <label>Service Charge(in ₹)</label>
                      <input className="form-control" type="text" name="service_charge" value={commissionData.service_charge} readOnly />
                    </li>
                    <li>
                      <label>Amount Collected(in ₹)</label>
                      <input className="form-control" type="text" value={commissionData ? (commissionData.collect_amount - commissionData.service_charge) : ""} readOnly />
                    </li>
                    <li>
                      <label>Exchange Rate</label>
                      <input className="form-control" type="text" value={commissionData.exchange_rate} readOnly />
                    </li>
                    <li>
                      <label>Amount Payable(in NPR)</label>
                      <input className="form-control" type="text" name="payout_amount" value={commissionData.payout_amount} readOnly />
                    </li>
                    {
                      (processId != "") ? (
                        <li>
                          <label>OTP:</label>
                          <input className="form-control" type="number" name="otp" required />
                        </li>
                      ) : (
                        <li></li>
                      )
                    }
                  </ul>
                </>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Transfer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={addReceiverModal} onHide={handleClose} centered size={processId == "" ? 'xl' : 'sm'} backdrop="static">
        <Form onSubmit={addReceiverSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Receiver</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              processId == "" ? (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <label>Sender Mobile Number</label>
                        <input className="form-control" type="text" name="sender_mobile_number" value={data && data.sender.MobileNo} />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Sender Name</label>
                        <input className="form-control" type="text" name="sender_name" value={data && ([data.sender.FirstName, data.sender.MiddleName, data.sender.LastName].filter(Boolean).join(" "))} />
                      </div>
                      {/* <div className="col-lg-4 col-md-4">
                        <label>Sender Occupation</label>
                        <select className="form-control" name="sender_occupation" value={data && data.sender.Occupation} onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {
                            Object.entries(occupation).map(([index, occ]) => (
                              <option value={index}>{occ}</option>
                            ))
                          }
                        </select>
                        <span className="error">{errors && errors?.sender_occupation}</span>
                      </div> */}
                      <div className="col-lg-4 col-md-4">
                        <label>Receiver Name</label>
                        <input className="form-control" type="text" name="receiver_name" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.receiver_name}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Receiver Gender</label>
                        <select className="form-control" name="receiver_gender" onChange={deleteError} requiredField="true">
                          <option value="">Select Gender</option>
                          <option value="1801">Male</option>
                          <option value="1802">Female</option>
                          <option value="1803">Other</option>
                        </select>
                        <span className="error">{errors && errors?.receiver_gender}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Receiver Mobile Number</label>
                        <input className="form-control" type="number" name="receiver_mobile_number" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.receiver_mobile_number}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Relationship</label>
                        <select className="form-control" name="relationship" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {
                            Object.entries(relationship).map(([index, rel]) => (
                              <option value={index}>{rel}</option>
                            ))
                          }
                        </select>
                        <span className="error">{errors && errors?.relationship}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Source of Fund</label>
                        <select className="form-control" name="source_of_fund" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {
                            Object.entries(sourceOfFund).map(([index, sof]) => (
                              <option value={index}>{sof}</option>
                            ))
                          }
                        </select>
                        <span className="error">{errors && errors?.source_of_fund}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Purpose of Remittance</label>
                        <select className="form-control" name="remittance_reason" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="3801">Family Maintenance</option>
                        </select>
                        <span className="error">{errors && errors?.remittance_reason}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Country</label>
                        <select className="form-control" name="country" onChange={getStateData} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="NPL">Nepal</option>
                        </select>
                        <span className="error">{errors && errors?.country}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Receiver State</label>
                        <select className="form-control" name="receiver_state" onChange={getDistrictData} requiredField="true">
                          <option value="">--Select--</option>
                          {states1 && states1.map((state, index) => (
                            <option value={state.state_id}>
                              {state.State}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.receiver_state}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Receiver District</label>
                        <select className="form-control" name="receiver_distict" onChange={(e) => getMunicipleData(e, idProof)} requiredField="true">
                          <option value="">--Select--</option>
                          {districts1 && districts1.map((district, index) => (
                            <option value={district.district_id}>
                              {district.district}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.receiver_distict}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Receiver Municipality</label>
                        <select className="form-control" name="receiver_municipality" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {municiple && municiple.map((mc, index) => (
                            <option value={mc.municipality_id}>
                              {mc.municipality}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.receiver_municipality}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Receiver Address</label>
                        <input className="form-control" type="text" name="receiver_address" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.receiver_address}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Payment Mode</label>
                        <select className="form-control" name="payment_type" onChange={getPaymentMode} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="C">Cash Payment</option>
                          <option value="B">Bank Deposit</option>
                        </select>
                        <span className="error">{errors && errors?.payment_type}</span>
                      </div>
                      {
                        (paymentData && paymentData.payment_type == "B") && (
                          <>
                            <div className="col-lg-4 col-md-4">
                              <label>Bank</label>
                              <select className="form-control" name="bank_id" onChange={getBankBranch} requiredField="true">
                                <option value="">--Select--</option>
                                {
                                  bankName && bankName.map((data, index) => (
                                    <>
                                      <option value={data.bank_id}>{data.bank}</option>
                                    </>
                                  ))
                                }
                              </select>
                              <span className="error">{errors && errors?.bank_id}</span>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <label>Bank Branch</label>
                              <select className="form-control" name="bank_branch_id" onChange={deleteError} requiredField="true">
                                <option value="">--Select--</option>
                                {
                                  bankBranchName && bankBranchName.map((data, index) => (
                                    <>
                                      <option value={data.branch_id}>{data.branch}</option>
                                    </>
                                  ))
                                }
                              </select>
                              <span className="error">{errors && errors?.bank_branch_id}</span>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <label>Account Number</label>
                              <input className="form-control" type="text" name="bank_account_number" onChange={deleteError} requiredField="true" />
                              <span className="error">{errors && errors?.bank_account_number}</span>
                            </div>
                          </>
                        )
                      }
                      <div className="col-lg-4 col-md-4">
                        <label>Transfer Amount(in ₹)</label>
                        <input className="form-control" type="number" name="collect_amount" onChange={(e) => getServiceCharge(e, paymentData)} min="700" max="50000" requiredField="true" />
                        <span className="error">{errors && errors?.collect_amount}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Service Charge(in ₹)</label>
                        <input className="form-control" type="text" name="service_charge" value={commissionData.service_charge} readOnly />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Amount Collected(in ₹)</label>
                        <input className="form-control" type="text" value={commissionData ? (commissionData.collect_amount - commissionData.service_charge) : ""} readOnly />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Exchange Rate</label>
                        <input className="form-control" type="text" value={commissionData.exchange_rate} readOnly />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Amount Payable(in NPR)</label>
                        <input className="form-control" type="text" name="payout_amount" value={commissionData.payout_amount} readOnly />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <label>OTP</label>
                        <input className="form-control" type="number" name="otp" onChange={deleteError} requiredField="true" />
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Create Receiver'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default ImeMoneyTransfer;
